var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgTiktok = function SvgTiktok(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11 22c6.075 0 11-4.925 11-11S17.075 0 11 0 0 4.925 0 11s4.925 11 11 11m4.463-15.032A3.26 3.26 0 0 0 17 7.353v2.395a5.57 5.57 0 0 1-3.286-1.068v4.89a4.5 4.5 0 0 1-.741 2.472A4.37 4.37 0 0 1 11 17.672a4.3 4.3 0 0 1-2.531.235 4.34 4.34 0 0 1-2.23-1.24 4.494 4.494 0 0 1-.773-5.09 4.4 4.4 0 0 1 1.866-1.93 4.3 4.3 0 0 1 2.62-.464v2.45a1.96 1.96 0 0 0-1.238.01c-.402.137-.75.4-.994.752a2.05 2.05 0 0 0 .041 2.394c.253.337.602.585 1 .71.399.125.825.12 1.22-.015a2 2 0 0 0 1.243-1.235c.076-.217.117-.447.118-.68V4h2.371v.309c.065.712.352 1.383.819 1.918.265.304.58.554.93.741",
    clipRule: "evenodd"
  })));
};
export { SvgTiktok as ReactComponent };
export default __webpack_public_path__ + "static/media/tiktok.1ec3488d1e31356c29c4a49f6deec5ac.svg";